export const products = {
  heaters: [
    {
      id: 'G50B',
      model: 'G50B',
      name: {
        it: 'Radiatore a infrarossi compatto 500W (Nero)',
        ru: 'Компактный инфракрасный обогреватель 500Вт (Черный)'
      },
      type: 'heater',
      power: '500W',
      wireless: 'WiFi, Bluetooth',
      size: '550x550x11mm',
      fullDeep: '61mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '9 kg',
      installation: {
        it: 'A parete (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-10 m\u00B2',
      color: 'black',
      gtin: '4745010656088',
      url: 'https://gpo-store.com/products/compact-infrared-glass-heater-500w',
      price: '\u20AC299',
      images: [
        'images/products/G50B/G50B-first.jpg',
        'images/products/G50B/G50B_1.jpg',
        'images/products/G50B/G50B_2.jpg',
        'images/products/G50B/G50B_3.jpg',
        'images/products/G50B/G50B_4.jpg',
        'images/products/G50B/G50B_5.jpg'
      ],
      description: {
        it: 'Radiatore a infrarossi compatto in vetro con design premium. Ideale per piccoli ambienti. Funzionamento silenzioso, sicuro per bambini e animali.',
        ru: 'Компактный инфракрасный стеклянный обогреватель с премиум дизайном. Идеален для небольших помещений. Бесшумная работа, безопасен для детей и питомцев.'
      }
    },
    {
      id: 'G50W',
      model: 'G50W',
      name: {
        it: 'Radiatore a infrarossi compatto 500W (Bianco)',
        ru: 'Компактный инфракрасный обогреватель 500Вт (Белый)'
      },
      type: 'heater',
      power: '500W',
      wireless: 'WiFi, Bluetooth',
      size: '550x550x11mm',
      fullDeep: '61mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '9 kg',
      installation: {
        it: 'A parete (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-10 m\u00B2',
      color: 'white',
      gtin: '4745010656095',
      url: 'https://gpo-store.com/products/compact-infrared-glass-heater-500w',
      price: '\u20AC299',
      images: [
        'images/products/G50W/G50W-first.jpg',
        'images/products/G50W/G50W_1.jpg',
        'images/products/G50W/G50W_2.jpg',
        'images/products/G50W/G50W_3.jpg',
        'images/products/G50W/G50W_4.jpg',
        'images/products/G50W/G50W_5.jpg'
      ],
      description: {
        it: 'Radiatore a infrarossi compatto in vetro bianco. Design premium che si adatta perfettamente a qualsiasi interno.',
        ru: 'Компактный инфракрасный стеклянный обогреватель белого цвета. Премиальный дизайн идеально вписывается в любой интерьер.'
      }
    },
    {
      id: 'G67W-V',
      model: 'G67W-V',
      name: {
        it: 'Radiatore a infrarossi premium 670W (Bianco, verticale)',
        ru: 'Премиум инфракрасный обогреватель 670Вт (Белый, вертикальный)'
      },
      type: 'heater',
      power: '670W',
      wireless: 'WiFi, Bluetooth',
      size: '1000x365x11mm',
      fullDeep: '61mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '10 kg',
      installation: {
        it: 'A parete (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-12 m\u00B2',
      color: 'white',
      gtin: '4745010656200',
      url: 'https://gpo-store.com/products/premium-infrared-silent-glass-heater-670w?variant=51179828379977',
      price: '\u20AC349',
      images: [
        'images/products/G67W-V/G67W-first.jpg',
        'images/products/G67W-V/G67W-V_1.jpg',
        'images/products/G67W-V/G67W-V_2.jpg',
        'images/products/G67W-V/G67W-V_3.jpg',
        'images/products/G67W-V/G67W-V_4.jpg',
        'images/products/G67W-V/G67W-V_5.jpg'
      ],
      description: {
        it: 'Elegante radiatore bianco di classe premium. Design ultrasottile di soli 11mm. Funzionamento silenzioso.',
        ru: 'Элегантный белый обогреватель премиум класса. Ультратонкий дизайн всего 11мм. Бесшумная работа.'
      }
    },
    {
      id: 'G67B-V',
      model: 'G67B-V',
      name: {
        it: 'Radiatore a infrarossi premium 670W (Nero, verticale)',
        ru: 'Премиум инфракрасный обогреватель 670Вт (Черный, вертикальный)'
      },
      type: 'heater',
      power: '670W',
      wireless: 'WiFi, Bluetooth',
      size: '1000x365x11mm',
      fullDeep: '61mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '10 kg',
      installation: {
        it: 'A parete (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-12 m\u00B2',
      color: 'black',
      gtin: '4745010656217',
      url: 'https://gpo-store.com/products/premium-infrared-silent-glass-heater-in-black-670w?variant=51179846107465',
      price: '\u20AC349',
      images: [
        'images/products/G67B-V/G67B-first.jpg',
        'images/products/G67B-V/G67B-V_1.jpg',
        'images/products/G67B-V/G67B-V_2.jpg',
        'images/products/G67B-V/G67B-V_3.jpg',
        'images/products/G67B-V/G67B-V_4.jpg',
        'images/products/G67B-V/G67B-V_5.jpg'
      ],
      description: {
        it: 'Radiatore premium silenzioso con installazione verticale. Elegante design nero, controllo intelligente tramite app.',
        ru: 'Премиальный тихий обогреватель вертикальной установки. Элегантный черный дизайн, умное управление через приложение.'
      }
    },
    {
      id: 'T67B-F3',
      model: 'T67B-F3',
      name: {
        it: 'Scaldasalviette-radiatore 670W (Nero, 3 barre)',
        ru: 'Полотенцесушитель-обогреватель 670Вт (Черный, 3 перекладины)'
      },
      type: 'towel-dryer',
      power: '670W',
      wireless: 'WiFi, Bluetooth',
      size: '1000x365x11mm',
      fullDeep: '150mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '11.5 kg',
      installation: {
        it: 'A parete (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-12 m\u00B2',
      color: 'black',
      racks: 3,
      gtin: '4745010656149',
      url: 'https://gpo-store.com/products/glass-heater-dryer-for-bathroom?variant=51179475829065',
      price: '\u20AC419',
      images: [
        'images/products/T67B-F3/T67B-F3-first.jpg',
        'images/products/T67B-F3/T67B-F3_1.jpg',
        'images/products/T67B-F3/T67B-F3_2.jpg',
        'images/products/T67B-F3/T67B-F3_3.jpg',
        'images/products/T67B-F3/T67B-F3_4.jpg',
        'images/products/T67B-F3/T67B-F3_5.jpg'
      ],
      description: {
        it: 'Scaldasalviette con tre barre per bagni familiari. Massima capacit\u00E0 per asciugamani.',
        ru: 'Полотенцесушитель с тремя перекладинами для семейных ванных комнат. Максимальная вместимость полотенец.'
      }
    },
    {
      id: 'T67W-F3',
      model: 'T67W-F3',
      name: {
        it: 'Scaldasalviette-radiatore 670W (Bianco, 3 barre)',
        ru: 'Полотенцесушитель-обогреватель 670Вт (Белый, 3 перекладины)'
      },
      type: 'towel-dryer',
      power: '670W',
      wireless: 'WiFi, Bluetooth',
      size: '1000x365x11mm',
      fullDeep: '150mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '11.5 kg',
      installation: {
        it: 'A parete (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-12 m\u00B2',
      color: 'white',
      racks: 3,
      gtin: '4745010656132',
      url: 'https://gpo-store.com/products/glass-heater-dryer-for-bathroom?variant=51179475763529',
      price: '\u20AC419',
      images: [
        'images/products/T67W-F3/T67W-F3-first.jpg',
        'images/products/T67W-F3/T67W-F3_1.jpg',
        'images/products/T67W-F3/T67W-F3_2.jpg',
        'images/products/T67W-F3/T67W-F3_3.jpg',
        'images/products/T67W-F3/T67W-F3_4.jpg',
        'images/products/T67W-F3/T67W-F3_5.jpg'
      ],
      description: {
        it: 'Scaldasalviette premium bianco con tre barre. Trasforma il tuo bagno in una spa.',
        ru: 'Премиальный белый полотенцесушитель с тремя перекладинами. Превратите ванную в спа-салон.'
      }
    }
  ],
  towelDryers: [
    {
      id: 'T50B-F1',
      model: 'T50B-F1',
      name: {
        it: 'Scaldasalviette-radiatore 500W (Nero, 1 barra)',
        ru: 'Полотенцесушитель-обогреватель 500Вт (Черный, 1 перекладина)'
      },
      type: 'towel-dryer',
      power: '500W',
      wireless: 'WiFi, Bluetooth',
      size: '550x550x11mm',
      fullDeep: '150mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '9.5 kg',
      installation: {
        it: 'A parete (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-10 m\u00B2',
      color: 'black',
      racks: 1,
      gtin: '4745010656170',
      url: 'https://gpo-store.com/products/500w-towel-dryer-heater',
      price: '\u20AC329',
      images: [
        'images/products/T50B-F1/T50B-F1_1.jpg',
        'images/products/T50B-F1/T50B-F1_2.jpg',
        'images/products/T50B-F1/T50B-F1_3.jpg',
        'images/products/T50B-F1/T50B-F1_4.jpg',
        'images/products/T50B-F1/T50B-F1_5.jpg'
      ],
      description: {
        it: 'Elegante scaldasalviette con riscaldamento dell\'intera piastra. Barre in acciaio inox, asciugatura asciugamani e riscaldamento bagno.',
        ru: 'Стильный полотенцесушитель с нагревом всей пластины. Нержавеющие перекладины, сушка полотенец и обогрев ванной.'
      }
    },
    {
      id: 'T50B-F2',
      model: 'T50B-F2',
      name: {
        it: 'Scaldasalviette-radiatore 500W (Nero, 2 barre)',
        ru: 'Полотенцесушитель-обогреватель 500Вт (Черный, 2 перекладины)'
      },
      type: 'towel-dryer',
      power: '500W',
      wireless: 'WiFi, Bluetooth',
      size: '550x550x11mm',
      fullDeep: '150mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '10 kg',
      installation: {
        it: 'A parete (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-10 m\u00B2',
      color: 'black',
      racks: 2,
      gtin: '4745010656163',
      url: 'https://gpo-store.com/products/500w-towel-dryer-heater?variant=51179804098889',
      price: '\u20AC349',
      images: [
        'images/products/T50B-F2/T50B-F2_1.jpg',
        'images/products/T50B-F2/T50B-F2_2.jpg',
        'images/products/T50B-F2/T50B-F2_3.jpg',
        'images/products/T50B-F2/T50B-F2_4.jpg',
        'images/products/T50B-F2/T50B-F2_5.jpg'
      ],
      description: {
        it: 'Scaldasalviette con due barre per pi\u00F9 asciugamani. Riscaldamento efficiente del bagno.',
        ru: 'Полотенцесушитель с двумя перекладинами для большего количества полотенец. Эффективный обогрев ванной комнаты.'
      }
    },
    {
      id: 'T50W-F1',
      model: 'T50W-F1',
      name: {
        it: 'Scaldasalviette-radiatore 500W (Bianco, 1 barra)',
        ru: 'Полотенцесушитель-обогреватель 500Вт (Белый, 1 перекладина)'
      },
      type: 'towel-dryer',
      power: '500W',
      wireless: 'WiFi, Bluetooth',
      size: '550x550x11mm',
      fullDeep: '150mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '9.5 kg',
      installation: {
        it: 'A parete (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-10 m\u00B2',
      color: 'white',
      racks: 1,
      gtin: '4745010656187',
      url: 'https://gpo-store.com/products/500w-towel-dryer-heater?variant=51179804131657',
      price: '\u20AC329',
      images: [
        'images/products/T50W-F1/T50W-F1_1.jpg',
        'images/products/T50W-F1/T50W-F1_2.jpg',
        'images/products/T50W-F1/T50W-F1_3.jpg',
        'images/products/T50W-F1/T50W-F1_4.jpg',
        'images/products/T50W-F1/T50W-F1_5.jpg'
      ],
      description: {
        it: 'Scaldasalviette bianco dal design premium. Il riscaldamento dell\'intera piastra in vetro garantisce un\'asciugatura uniforme.',
        ru: 'Белый полотенцесушитель премиум дизайна. Нагрев всей стеклянной пластины обеспечивает равномерную сушку.'
      }
    },
    {
      id: 'T50W-F2',
      model: 'T50W-F2',
      name: {
        it: 'Scaldasalviette-radiatore 500W (Bianco, 2 barre)',
        ru: 'Полотенцесушитель-обогреватель 500Вт (Белый, 2 перекладины)'
      },
      type: 'towel-dryer',
      power: '500W',
      wireless: 'WiFi, Bluetooth',
      size: '550x550x11mm',
      fullDeep: '150mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '10 kg',
      installation: {
        it: 'A parete (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-10 m\u00B2',
      color: 'white',
      racks: 2,
      gtin: '4745010656194',
      url: 'https://gpo-store.com/products/500w-towel-dryer-heater?variant=51179804164425',
      price: '\u20AC349',
      images: [
        'images/products/T50B-F2/T50B-F2_1.jpg',
        'images/products/T50B-F2/T50B-F2_2.jpg',
        'images/products/T50B-F2/T50B-F2_3.jpg',
        'images/products/T50B-F2/T50B-F2_4.jpg',
        'images/products/T50B-F2/T50B-F2_5.jpg'
      ],
      description: {
        it: 'Scaldasalviette bianco con due barre. Design moderno per bagni luminosi.',
        ru: 'Белый полотенцесушитель с двумя перекладинами. Современный дизайн для светлых интерьеров ванных комнат.'
      }
    },
    {
      id: 'T67B-F2',
      model: 'T67B-F2',
      name: {
        it: 'Scaldasalviette-radiatore 670W (Nero, 2 barre)',
        ru: 'Полотенцесушитель-обогреватель 670Вт (Черный, 2 перекладины)'
      },
      type: 'towel-dryer',
      power: '670W',
      wireless: 'WiFi, Bluetooth',
      size: '1000x365x11mm',
      fullDeep: '150mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '11 kg',
      installation: {
        it: 'A parete (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-12 m\u00B2',
      color: 'black',
      racks: 2,
      gtin: '4745010656156',
      url: 'https://gpo-store.com/products/glass-heater-dryer-for-bathroom?variant=51179475796297',
      price: '\u20AC399',
      images: [
        'images/products/T67B-F2/T67B-F2_1.jpg',
        'images/products/T67B-F2/T67B-F2_2.jpg',
        'images/products/T67B-F2/T67B-F2_3.jpg',
        'images/products/T67B-F2/T67B-F2_4.jpg',
        'images/products/T67B-F2/T67B-F2_5.jpg'
      ],
      description: {
        it: 'Potente scaldasalviette per bagni grandi. Design verticale salvaspazio.',
        ru: 'Мощный полотенцесушитель для больших ванных комнат. Вертикальный дизайн экономит пространство.'
      }
    },
    {
      id: 'T67W-F2',
      model: 'T67W-F2',
      name: {
        it: 'Scaldasalviette-radiatore 670W (Bianco, 2 barre)',
        ru: 'Полотенцесушитель-обогреватель 670Вт (Белый, 2 перекладины)'
      },
      type: 'towel-dryer',
      power: '670W',
      wireless: 'WiFi, Bluetooth',
      size: '1000x365x11mm',
      fullDeep: '150mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '11 kg',
      installation: {
        it: 'A parete (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-12 m\u00B2',
      color: 'white',
      racks: 2,
      gtin: '4745010656125',
      url: 'https://gpo-store.com/products/glass-heater-dryer-for-bathroom?variant=51179475730761',
      price: '\u20AC399',
      images: [
        'images/products/T67W-F2/T67W-F2_1.jpg',
        'images/products/T67W-F2/T67W-F2_2.jpg',
        'images/products/T67W-F2/T67W-F2_3.jpg',
        'images/products/T67W-F2/T67W-F2_4.jpg',
        'images/products/T67W-F2/T67W-F2_5.jpg'
      ],
      description: {
        it: 'Scaldasalviette bianco di classe premium. Si integra perfettamente in interni moderni e minimalisti.',
        ru: 'Белый полотенцесушитель премиум класса. Идеально вписывается в современные минималистичные интерьеры.'
      }
    }
  ],
  shoeDryers: [
    {
      id: 'S10B-F2',
      model: 'S10B-F2',
      name: {
        it: 'Asciugascarpe a infrarossi 100W (Nero)',
        ru: 'Инфракрасная сушилка для обуви 100Вт (Черная)'
      },
      type: 'shoe-dryer',
      power: '100W',
      wireless: 'WiFi, Bluetooth',
      size: '550x550x11mm',
      fullDeep: '150mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '10 kg',
      installation: {
        it: 'A parete (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      color: 'black',
      gtin: '474501065610',
      url: 'https://gpo-store.com/products/infrared-shoe-dryer',
      price: '\u20AC249',
      images: [
        'images/products/S10B-F2/S10B-F2_1.jpg',
        'images/products/S10B-F2/S10B-F2_2.jpg',
        'images/products/S10B-F2/S10B-F2_3.jpg',
        'images/products/S10B-F2/S10B-F2_4.jpg',
        'images/products/S10B-F2/S10B-F2_5.jpg'
      ],
      description: {
        it: 'Asciugascarpe intelligente con riscaldamento a infrarossi. Asciuga le scarpe rapidamente e delicatamente senza danneggiare i materiali.',
        ru: 'Умная сушилка для обуви с инфракрасным нагревом. Быстро и бережно сушит обувь, не повреждая материалы.'
      }
    },
    {
      id: 'S10W-F2',
      model: 'S10W-F2',
      name: {
        it: 'Asciugascarpe a infrarossi 100W (Bianco)',
        ru: 'Инфракрасная сушилка для обуви 100Вт (Белая)'
      },
      type: 'shoe-dryer',
      power: '100W',
      wireless: 'WiFi, Bluetooth',
      size: '550x550x11mm',
      fullDeep: '150mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '10 kg',
      installation: {
        it: 'A parete (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      color: 'white',
      gtin: '4745010656118',
      url: 'https://gpo-store.com/products/infrared-shoe-dryer?variant=51179383062857',
      price: '\u20AC249',
      images: [
        'images/products/S10W-F2/S10W-F2_1.jpg',
        'images/products/S10W-F2/S10W-F2_2.jpg',
        'images/products/S10W-F2/S10W-F2_3.jpg',
        'images/products/S10W-F2/S10W-F2_4.jpg',
        'images/products/S10W-F2/S10W-F2_5.jpg'
      ],
      description: {
        it: 'Asciugascarpe bianco con controllo WiFi. Soluzione moderna per ingresso o guardaroba.',
        ru: 'Белая сушилка для обуви с WiFi управлением. Современное решение для прихожей или гардеробной.'
      }
    }
  ]
};

export const features = {
  it: [
    {
      icon: '\u26A1',
      title: 'Risparmio fino al 40%',
      description: 'Consumo reale 250-300W/h invece dei 500-670W nominali. Meno di 1 kW!'
    },
    {
      icon: '\u{1F525}',
      title: 'Riscaldamento ibrido',
      description: 'Combinazione di infrarossi (60-70%) e convezione (30-40%) per comfort immediato.'
    },
    {
      icon: '\u{1F4F1}',
      title: 'Controllo WiFi',
      description: 'Gestisci la temperatura da smartphone ovunque tu sia. App gratuita iOS/Android.'
    },
    {
      icon: '\u{1F3E0}',
      title: 'Showroom a Battipaglia',
      description: 'Vieni a toccare con mano i prodotti presso lo showroom Perfectwin.'
    },
    {
      icon: '\u2728',
      title: 'Design ultrasottile',
      description: 'Spessore di soli 11mm. Elegante vetro nero o bianco che si integra in ogni ambiente.'
    },
    {
      icon: '\u{1F476}',
      title: 'Sicurezza certificata',
      description: 'Sicuro per bambini e animali. Temperatura superficiale controllata, certificato CE.'
    },
    {
      icon: '\u{1F507}',
      title: 'Zero rumore',
      description: 'Funzionamento completamente silenzioso. Ideale per camere da letto e uffici.'
    },
    {
      icon: '\u{1F4A8}',
      title: 'Aria sana',
      description: 'Non brucia polvere, non secca l\'aria. Perfetto per chi soffre di allergie.'
    },
    {
      icon: '\u{1F48E}',
      title: 'Qualità europea',
      description: 'Vetro temperato premium con 5 anni di garanzia. Produzione controllata.'
    },
    {
      icon: '\u{1F4C5}',
      title: 'Programmazione smart',
      description: 'Timer settimanale, rilevamento finestra aperta, integrazione prezzi energia Nord Pool.'
    }
  ],
  ru: [
    {
      icon: '\u26A1',
      title: 'Экономия до 40%',
      description: 'Реальное потребление 250-300Вт/ч вместо номинальных 500-670Вт. Менее 1 кВт!'
    },
    {
      icon: '\u{1F525}',
      title: 'Гибридный нагрев',
      description: 'Сочетание инфракрасного (60-70%) и конвекционного (30-40%) нагрева для мгновенного комфорта.'
    },
    {
      icon: '\u{1F4F1}',
      title: 'WiFi управление',
      description: 'Управляйте температурой со смартфона из любой точки мира. Бесплатное приложение iOS/Android.'
    },
    {
      icon: '\u{1F3E0}',
      title: 'Шоурум в Баттипалья',
      description: 'Приходите оценить продукты вживую в шоуруме Perfectwin.'
    },
    {
      icon: '\u2728',
      title: 'Ультратонкий дизайн',
      description: 'Толщина всего 11мм. Элегантное черное или белое стекло для любого интерьера.'
    },
    {
      icon: '\u{1F476}',
      title: 'Сертифицированная безопасность',
      description: 'Безопасно для детей и животных. Контролируемая температура поверхности, сертификат CE.'
    },
    {
      icon: '\u{1F507}',
      title: 'Абсолютная тишина',
      description: 'Полностью бесшумная работа. Идеально для спален и офисов.'
    },
    {
      icon: '\u{1F4A8}',
      title: 'Здоровый воздух',
      description: 'Не сжигает пыль, не сушит воздух. Отлично для аллергиков.'
    },
    {
      icon: '\u{1F48E}',
      title: 'Европейское качество',
      description: 'Премиальное закаленное стекло с 5-летней гарантией. Контролируемое производство.'
    },
    {
      icon: '\u{1F4C5}',
      title: 'Умное программирование',
      description: 'Недельный таймер, обнаружение открытого окна, интеграция с ценами энергии Nord Pool.'
    }
  ]
};

export const contact = {
  address: {
    it: 'via Belvedere, 59, 84091 Battipaglia (SA)',
    ru: 'via Belvedere, 59, 84091 Battipaglia (SA)'
  },
  phone: '+39 351 3857921',
  email: 'marketing@gpo-home.com',
  facebook: 'https://www.facebook.com/profile.php?id=61585413089245',
  company: {
    name: 'GPO O\u00DC',
    fullAddress: 'Peterburi tee 38/9, Tallinn, Estonia, 11415',
    reg: '14897399',
    vat: 'EE102227529'
  }
};
